import { IFramework } from '@/framework';
import { ILayerProps } from '@/version-types';
import { CornerPoint } from '../types';

export const GLFX_CANVAS_ID = 'glfx-canvas';
export const StageWidthScale = 2;

const RenderStage: React.FC<{
    scale: number;
    activeLayer: ILayerProps;
    framework: IFramework;
    latestPoints: CornerPoint[];
    startPoints: CornerPoint[];
}> = ({ scale, activeLayer }) => {
    return (
        <div className="c-deformation-img-render-stage" id="deformation-img-render-stage">
            <div
                style={{
                    width: activeLayer.width * StageWidthScale,
                    height: activeLayer.height * StageWidthScale,
                    transform: `scale(${scale})`,
                    transformOrigin: 'center center',
                }}
            >
                <canvas
                    style={{
                        width: activeLayer.width * StageWidthScale,
                        height: activeLayer.height * StageWidthScale,
                    }}
                    id={GLFX_CANVAS_ID}
                />
            </div>
        </div>
    );
};

export default RenderStage;
